import Aura from '@primeng/themes/aura';
import { definePreset } from '@primeng/themes';

export const customPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{green.50}',
      100: '{green.100}',
      200: '{green.200}',
      300: '{green.300}',
      400: '{green.400}',
      500: '{green.800}',
      600: '{green.600}',
      700: '{green.700}',
      800: '{green.800}',
      900: '{green.900}',
      950: '{green.950}'
    },
    surface: {
      0: '#ffffff',
      50: '{neutral.50}',
      100: '{neutral.100}',
      200: '{neutral.200}',
      300: '{neutral.300}',
      400: '{neutral.400}',
      500: '{neutral.500}',
      600: '{neutral.600}',
      700: '{neutral.700}',
      800: '{neutral.800}',
      900: '{neutral.900}',
      950: '{neutral.950}'
    }
  },
  components: {
    paginator: {
      nav: {
        button: {
          hover: {
            color: '{surface.900}',
            background: '{surface.200}'
          },
          selected: {
            background: '{primary.900}',
            color: 'white'
          }
        }
      }
    },
    datepicker: {
      panel: {
        background: '{surface.0}',
      },
      header: {
        background: '{surface.0}',
        color: '{stone:900}',
        padding: '2px',
        gap: '1px'
      },
      dropdown: {
        borderColor: '#115740',
        hoverBorderColor: '#115740',
        activeBorderColor: '#115740'
      },
      colorScheme: {
        light: {
          dropdown: {
            background: '#115740',
            color: '#fff',
            hoverBackground: '#115740',
            hoverColor: '#fff',
            activeBackground: '#115740',
            activeColor: '#fff'
          }
        }
      },
      date: {
        width: '2rem',
        height: '2rem',
        hover: {
          background: '{stone.300}'
        }
      },
      css: () => `
        .p-datepicker {
          width: 100%;
        }

        .p-datepicker .p-inputtext {
          height: 2.357rem;
        }

        .p-datepicker-dropdown:disabled {
          pointer-events: none;
          opacity: 0.5;
        }

        .p-datepicker-select-year{          
          font-size: larger;
        }
          
        .p-datepicker-select-month{
          font-size: larger;
        }
      `
    },
    tabs: {
      tablist: {
        background: '#e0ede9',
        borderColor: '#e0ede9',
      },
      tab: {
        background: 'transparent',
        padding: '0.5rem 1rem',
        margin: '0',
        color: '#115740',
        borderColor: '{surface.0}', 
        borderWidth: '0 0.25px 0 0.25px',
        active: {
          background: 'rgb(7 118 55 / 0.1)',
          color: '#115740',
          borderColor: '{surface.0}',
          borderWidth: '0 0 2px 0',
        }
      },
      tabpanel: {
        borderColor: '#eee',
        borderWidth: '1px',
        borderStyle: 'solid', 
        padding: '0.7rem 0.8rem',
        shadow: '1px 2px 11px -9px',
        background: '{surface.0}'
      },
      nav: { 
        button: {
          color: '{surface.0}',
          background: '{primary.700}',
          padding: '0',
          borderWidth: '0',
          hover: {
            color: '{surface.0}',
            background: '{primary.900}',
          }
        }
      }
    },
    message:{
       colorScheme: {
         warn: {                        
            color: '{yellow.800}',
            background: '{yellow.100}',                  
         }                
      }
    },
    inputtext:{
      color: '#000',
    },
    select:{
      color: '#000',
      option: {
        selected: {
          background: 'rgba(33, 150, 243, 0.24)',
          color: '#000',
          focus: {
            background: 'rgba(33, 150, 243, 0.24)',
            color: '#000'
          }
        }
      },
      focus: {
        border: {
          color: '#e0ede9'
        },
        // Border style for whole p-select component when focused
        ring: {
          width: '0.2rem',
          style: 'solid',
          color: '#e0ede9',
          shadow: '0 0 0 0.2rem #e0ede9'
        }
      },
      padding: {
        y: '0.875rem', // Vertical padding between each element
      },
      disabled:{
        background: 'rgb(233, 236, 239)',
        color: '#000'
      }
    },
    checkbox: {
      border: {
        color: '#ced4da'
      },
      hover: {
        border: {
          color: '#115740'
        }
      },
      focus: {
        border: {
          color: '#115740'
        }
      },
      disabled: {
        background: '#115740'
      },
      checked: {
        background: '#115740',
        border: {
          color: '#115740'
        },
        hover: {
          background: '#115740',
          border: {
            color: '#115740'
          },
          color: '{surface.0}'
        },
        disabled: {
          border: {
            color: '#115740'
          }
        }
      },
      icon: {
        disabled: {
          color: '{surface.0}'        
        }
      }
    },
    card: {
      color: '#000',
      body: {
        padding: '1rem'
      }
    },
    dialog: {
      color: '#000'
    },
    toast: {
      border: {
        width: '0 0 0 6px'
      },
      content: {
        padding: '1rem',
        gap: '1rem'
      },
      colorScheme: {
        error: {
          background: '#ffcdd2',
          border: {
            color: '#e60017'
          },
          color: '#73000c'
        }
      }
    },
    radiobutton: {
      hover: {
        border: {
          color: '{primary.900}'
        }
      }
    }
  }
});